import type { MisconceptionDefinition } from '../types'
import { GET_BASIS } from './basis'
import { GET_KOMMA } from './komma'
import { GET_BREUKEN } from './breuken'
import { GET_PROCENTEN } from './procenten'
import { GET_VERHOUDINGEN } from './verhoudingen'
import { GET_MACHTEN } from './machten'
import { GET_NEGATIEF } from './negatief'
import { GET_AFRONDEN } from './afronden'

export const GET_MISCONCEPTIONS: MisconceptionDefinition[] = [
  ...GET_BASIS,
  ...GET_KOMMA,
  ...GET_BREUKEN,
  ...GET_PROCENTEN,
  ...GET_VERHOUDINGEN,
  ...GET_MACHTEN,
  ...GET_NEGATIEF,
  ...GET_AFRONDEN,
]
